<template>
  <div class="schoolPicker">
    <w-input
      placeholder="Szukaj szkoły..."
      title="Wyszukiwarka szkół"
      type="search"
      :model="$schema.selectedSubschool"
      @input="search"
    />

    <div class="mt-3 pb-4 filters">
      <checkbox-list :schema="schema.names" :filter="{ options }" title="" @update="$emit('update')" />
    </div>
  </div>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';

import { SchoolFinancing, schoolFinancingList } from '@/enums/schoolFinancing.enum';
import { schoolPickerMixin } from '@/mixins/document/schoolPicker';
import { formMixin } from '@/mixins/form';
import schema from '@/schemas/schoolPickerFilters.schema';

import CheckboxList from './CheckboxList';

// @vuese
// Formularz wyboru szkoły
export default {
  components: { ...components, CheckboxList },
  mixins: [formMixin, schoolPickerMixin],
  schema,
  props: {
    // schema
    schema: { type: Object, required: true },
    // tytuł pola
    title: { type: String, required: true }
  },
  data() {
    return {
      SchoolFinancing,
      financingList: schoolFinancingList
    };
  },
  methods: {
    // @vuese
    // Wyszukuje szkoły
    search(search) {
      this.$store
        .dispatch('structureNode/list', {
          search,
          hasOrder: true,
          hasParentOrChildren: true,
          count: -1,
          order: 'order',
          desc: false
        })
        .then(result => {
          this.options = result.list.map(school => ({ text: school.name, value: school.name }));
        });
    }
  }
};
</script>

<style>
.schoolPicker .filters {
  -webkit-column-count: 3;
  -moz-column-count: 3;
  column-count: 3;
}
</style>
